import type { IOffer } from "@bbj-types/offer";
import { isInternalOfferSource } from "@root/utils/enums/offer";

export const getMatchedEnterprise = (offer: Pick<IOffer, "source" | "enterprise" | "matchedEnterprise">) => {
  return !isInternalOfferSource(offer.source) || offer.enterprise?._id === offer.matchedEnterprise?.enterpriseId
    ? offer.matchedEnterprise
    : undefined;
};
